const THREE = window.THREE;

class UNPlaceState {
    constructor( app, options) {
        this.app = app;
        this.options = options;

        this.tempVec3 = new THREE.Vector3();
        this.tempQut = new THREE.Quaternion();
    }

    createBox(obj, isAijiu)
    {
        console.log( obj );

        obj.geometry.computeBoundingBox();

        let  boundingBox = obj.geometry.boundingBox;
        boundingBox.getSize( this.tempVec3 );

        let geo = new THREE.BoxGeometry(0.1,0.1,0.1);

        let box = new THREE.Mesh(geo, this.highlightMat)
        obj.getWorldQuaternion(this.tempQut);

        let temp = new THREE.Vector3();

        box.position.copy( obj.getWorldPosition(temp) );
        // let quat2 = new THREE.Quaternion();
        // quat2.setFromAxisAngle(new THREE.Vector3(1,0,0), Math.PI);
        // this.tempQut.multiply( quat2 );
        box.quaternion.copy( this.tempQut );

        if( isAijiu ) {
            this.tempVec3.z *= 0.16;
            this.tempVec3.x *= 0.16;
            this.tempVec3.y *= 0.28;
        } else {
            this.tempVec3.z *= 4;
            this.tempVec3.x *= 20;
            this.tempVec3.y *= 20;
        }
    

        box.scale.copy( obj.scale )
						.multiply( this.tempVec3 )
                        .multiplyScalar( 5 );

        this.app.scene.add( box );

        box.name = obj.objname;
        box.objname = obj.objname;

        box.visible = false;
        return box;
    }

    enter() {
        console.log('enter unplace', this.options);


        this.INTERSECTED = null;
        this.raycaster = new THREE.Raycaster();
        let highlightMat = new THREE.MeshLambertMaterial( {
            emissive: 0xffff00,
            transparent: true,
            opacity: 0.5
        });
        this.highlightMat = highlightMat;

        this.placedObj = [];
        this.addedObj = {};
        this.removedObj = {};

        this.placedBox = [];

        if( this.app.placedAijiu ) {
            this.addedObj['aijiu'] = this.app.placedAijiu;

            let addedBox = false;
            this.app.placedAijiu.traverse(node=>{
                if(node.isMesh && !addedBox ) {
                    this.placedObj.push(node);
                    node.objname = 'aijiu';
                    addedBox = true;
                    let box = this.createBox( node , true);
                    this.placedBox.push( box );
                }
            })
            this.placedObj.push(this.app.placedAijiu);
        }

        if( this.app.placedYinzhen ) this.app.placedYinzhen.forEach(item=>{
            item.traverse(node=>{
                if(node.isMesh ) {
                    this.placedObj.push( node );
                    node.objname = item.placeName;

                    let box = this.createBox( node )
                    this.placedBox.push( box );
                }
            })
            this.addedObj[item.placeName] = item;
        });

        let n = this.placedBox.length;
        while(n--) this.placedObj.push( this.placedBox[n] );

        this.app.setRentiRotate('up');
    }

    onClick(){
        let obj = this.hoverCheck();
        if( obj ) {
            console.log( obj );
            let added = this.addedObj[obj.objname];
            this.removedObj[obj.objname] = added

            this.app.scene.remove( added );

            let n = this.placedObj.length 
            while( n-- ) {
                let item = this.placedObj[n];
                if( item.objname == obj.objname ) {
                    this.placedObj.splice(n,1);
                }
            }

            n = this.placedBox.length 
            while( n-- ) {
                let item = this.placedBox[n];
                if( item.objname == obj.objname ) {
                    this.placedBox.splice(n,1);
                    this.app.scene.remove( item );
                }
            }

            setTimeout(() => {
                window.Bus.emit("zhenout", obj.objname);
            }, 200);
        }
    } 

    exit(){
        let addedObjs = this.addedObj;
        for( let name in addedObjs) {
            this.app.scene.remove( addedObjs[name] );
        }

        let n = this.placedBox.length 
        while( n-- ) {
            let item = this.placedBox[n];
            this.app.scene.remove( item );
        }
    }
    
    hoverCheck( )
    {
        if( this.placedObj.length < 1) return;

        let raycaster = this.raycaster;

        raycaster.setFromCamera( this.app.mouse, this.app.activeCamera);

        let n = this.placedBox.length;
        while(n--) this.placedBox[n].visible = true;

        let intersections = raycaster.intersectObjects( this.placedBox , true);
        n = this.placedBox.length;
        while(n--) this.placedBox[n].visible = false;

        let INTERSECTED = this.INTERSECTED;

        if( intersections && intersections.length > 0 )
        {
            let intersectionObj = intersections[0].object;
            intersectionObj.visible = true;

            if ( INTERSECTED != intersectionObj ) {

                console.log( intersectionObj );

                // if ( INTERSECTED ) INTERSECTED.material = INTERSECTED.currentHex ;

                INTERSECTED = intersectionObj;
                this.INTERSECTED = intersectionObj;

                // INTERSECTED.currentHex = INTERSECTED.material
                // INTERSECTED.material = this.highlightMat;
            }
            return intersectionObj;
        } 

        if ( INTERSECTED ) {
            // INTERSECTED.material = INTERSECTED.currentHex;
            INTERSECTED.visible = false;
        }

        this.INTERSECTED = null;
    }
    update() {
        this.hoverCheck();

        let n = this.options.length;
        while( n-- )
        {
            let item = this.options[n];
            
            if( this.removedObj[item.name] ) {
                item.dom.style.left = '-100px';
                continue;
            }

            let node = this.addedObj[item.name];


            node.getWorldPosition( this.tempVec3 );
        
            this.tempVec3.project( this.app.activeCamera );
            let x =  ( 1 + this.tempVec3.x ) * 0.5 * this.app.el.clientWidth;
            let y =  ( 1 - this.tempVec3.y ) * 0.5 * this.app.el.clientHeight;
            
            let dom = item.dom;
            dom.style.left = x + 'px';
            dom.style.top = y + 'px';
        }
        
    }
}


export default UNPlaceState;